<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { loadWorkflowCached } from '../api/workflows';
import type { Notification } from 'vince-core/types/notifications';

const { t } = useI18n();
const { formatDateTime } = useFormatting();

const emit = defineEmits<{
    'notification-click': [Notification]
}>();

const props = defineProps<{
    notification: Notification
}>();

const workflow = ref<Workflow | null>(null);
const workflowName = ref<string>();

const status = computed(() => {
    return props.notification.eventName.split(':').at(-1);
});

watch(() => props.notification.keys.workflowId!, async (newVal: string) => {
    workflow.value = (await loadWorkflowCached(newVal));
    workflowName.value = workflow.value?.workflowAlias || workflow.value?.workflowName;
}, { immediate: true });

const handleClick = async () => {
    await navigateTo({
        name: 'workflows-workflowId-executions-executionId',
        params: { 
            workflowId: props.notification.keys.workflowId!,
            executionId: props.notification.keys.executionId!
        }
    });
    emit('notification-click', props.notification);
};
</script>

<template>
    <div class="cursor-pointer" @click="handleClick">
        <div>{{ t('workflows.notification.workflow', {workflowName, status: t(`workflows.notification.status.${status}`)}) }}</div>
        <div class="flex items-center gap-2 font-light text-sm">
            <span>{{ formatDateTime(notification.timestamp) }}</span>
            <span class="underline">{{ t('workflows.notification.view') }}</span>
        </div>
    </div>
</template>
